import { useMutation, useQuery } from '@tanstack/react-query'
import { apiFetch } from './client'

interface MonitorUrlsResponse {
  call_id: string
  status: string
  listen_url: string
  control_url: string
  phone_call_provider_id: string
}

interface BargeInResponse {
  success: boolean
  token: string
  conference_name: string
  identity: string
}

interface MonitorResponse {
  success: boolean
  token: string
  conference_name: string
  identity: string
  dial_in_number: string | null
}

export function useGetMonitorUrls(callId: string | undefined) {
  return useQuery({
    queryKey: ['monitor-urls', callId],
    queryFn: () => apiFetch<MonitorUrlsResponse>(`/vapi/calls/${callId}/monitor`),
    enabled: !!callId,
    staleTime: 30_000,
  })
}

export function useBargeInMutation() {
  return useMutation({
    mutationFn: (callId: string) =>
      apiFetch<BargeInResponse>(`/vapi/calls/${callId}/barge-in`, {
        method: 'POST',
      }),
  })
}

export function useMonitorMutation() {
  return useMutation({
    mutationFn: (callId: string) =>
      apiFetch<MonitorResponse>(`/simulations/calls/${callId}/monitor`, {
        method: 'POST',
      }),
  })
}
